---
nb:
  portfolio_stats:
    aggregated_intraday_hourly_revenue: Aggregert timeinntekt intradag
    click_to_refresh: Klikk her for å bekrefte
    heading: Porteføljestatistikk
    hourly_revenue: Timeinntekt
    hourly_revenue_warning: Diagram timeinntekt er deaktivert når det er mer enn 200 kraftverk
    monthly_revenue: Månedlig inntekt
    of_budget: av budsjett
    portfolio_production: Porteføljeoversikt produksjon
    portfolio_total: Porteføljetotal
    power_plant_age_distribution: Kraftverks aldersfordeling
    power_plants_yearly_load_hour: Kraftverks årlige lasttimer
    prod_and_runoff_vs_normal: Produksjon og avrenning vs. normal
    prod_vs_bud: Produksjon vs. budsjett
    prod_vs_normal: Produksjon vs. normal
    prod_vs_normal_ytd: Produksjon vs. normal i år
    production_ytd: Produksjon i år
    rev_and_bud: Inntekter og budsjett
    rev_and_bud_ytd: Inntekter og budsjett så langt i år
    rev_vs_bud: Inntekter vs. budsjett
    rev_vs_bud_ytd: Inntekter vs. budsjett så langt i år
    revenue_ytd: Inntekter YTD
    runoff_vs_average: Avrenning vs. gjennomsnitt
    runoff_vs_normal_ytd: Produksjon og avrenning vs normal så langt i år
    technical_downtime: Oversikt teknisk nedetid
